export default {"src":"/_next/static/media/0x6c3ea9036406852006290770bedfcaba0e23a0e8.11297693.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};